import './Banner.scss';
import React from 'react';
import PropTypes from 'prop-types';

export default function Banner (props) {
  const { type, message, button, className } = props;

  return (
    <div className={`banner banner-${type}${className ? ` ${className}` : ''}`} data-testid='banner'>
      <div className='banner-text'>
        {message}
        <>{button}</>
      </div>
    </div>
  );
}
Banner.propTypes = {
  message: PropTypes.string.isRequired,
  button: PropTypes.element,
  type: PropTypes.oneOf(['info', 'warning', 'error']),
  className: PropTypes.string
};
Banner.defaultProps = {
  type: 'info',
  button: null,
  className: ''
};
